export const reactSelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '45px', // Only minHeight — let height grow automatically
    width: '100%',
    fontSize: '14px',
     boxSizing: 'border-box',
    borderColor: state.isFocused ? '#7F56DA' : base.borderColor,
    boxShadow: state.isFocused ? '0 0 0 1px #7F56DA' : base.boxShadow,
    '&:hover': {
      borderColor: '#7F56DA',
    },
    flexWrap: 'wrap', // Ensures multi-values wrap
    alignItems: 'center' // Align tags at the top
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '4px 8px',
    fontSize: '14px',
    flexWrap: 'wrap',
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: '#f0f0f0',
    borderRadius: '4px',
    padding: '2px 4px',
    fontSize: '13px',
  }),
  placeholder: (base) => ({
    ...base,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    color: '#999',
  }),
  option: (base, state) => ({
    ...base,
    fontSize: '14px',
    backgroundColor: state.isSelected
      ? '#ddd'
      : state.isFocused
        ? '#f0f0f0'
        : 'white',
    color: 'black',
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
}),
};


export const locationSelectStyle = {
  control: (base) => ({
    ...base,
    fontSize: '14px',
    borderRadius: '12px',
    borderColor: '#7F56DA',
    boxShadow: '0 0 0 1px #7F56DA',
    minHeight: '45px',
    '&:hover': {
      borderColor: '#7F56DA',
    },
  }),
  option: (base, state) => ({
    ...base,
    fontSize: '14px',
    backgroundColor: state.isSelected
      ? '#ddd'
      : state.isFocused
        ? '#f0f0f0'
        : 'white',
    color: 'black',
    cursor: 'pointer',
  }),
  menu: (base) => ({
    ...base,
    borderRadius: '10px',
    overflow: 'hidden',
    zIndex: 9999,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
};



    // GridToggleIcon.jsx
   export  const GridToggleIcon = ({ isDisabled = false, size = 22 }) => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={isDisabled ? "#bbb" : "#7F56DA"}   // ✅ auto color
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect x="3" y="3" width="7" height="7" />
            <rect x="14" y="3" width="7" height="7" />
            <rect x="14" y="14" width="7" height="7" />
            <path d="M3 14h3v3H3zM10 14h1v7h-1zM10 10h1v1h-1z" />
        </svg>
    );